const CommonEndPoints = Object.freeze({
  GET :  `get`,
  UPDATE : `update`,
  CREATE : `create`,
  DELETE : `delete`
})

export default CommonEndPoints